import React, { useEffect, useState } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import ImportantToKnow from "../components/ImportantToKnow";
import api from "../api/Api.js";
import { useLanguage } from "../context/LanguageContext";

const FAQ = () => {
  // =====================================================
  // LANGUAGE
  // =====================================================

  const { language } = useLanguage();

  // =====================================================
  // STATES
  // =====================================================

  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeFaq, setActiveFaq] = useState(null);

  // =====================================================
  // GET LANGUAGE ID
  // =====================================================

  const getLanguageId = () => {
    if (
      typeof language === "number" ||
      !isNaN(Number(language))
    ) {
      return Number(language);
    }

    if (
      language &&
      typeof language === "object"
    ) {
      return (
        Number(
          language.lang_id ||
          language.language_id ||
          language.id
        ) || 1
      );
    }

    return 1;
  };

  const languageId = getLanguageId();

  // =====================================================
  // LOAD FAQS
  // =====================================================

  useEffect(() => {
    let cancelled = false;

    const loadFaqs = async () => {
      try {
        setLoading(true);
        setError("");

        console.log("====================================");
        console.log("FAQ REQUEST");
        console.log("LANGUAGE ID:", languageId);
        console.log("====================================");

        const response = await api.get("/faqs", {
          params: {
            lang_id: languageId,
          },
        });

        console.log(
          "FAQ RESPONSE:",
          response.data
        );

        if (cancelled) {
          return;
        }

        if (
          response.data?.success &&
          Array.isArray(response.data.data)
        ) {
          setFaqs(response.data.data);

          // Open first FAQ automatically
          if (response.data.data.length > 0) {
            setActiveFaq(
              response.data.data[0].faq_id
            );
          }
        } else {
          setFaqs([]);
          setError("No FAQs found.");
        }
      } catch (error) {
        console.error(
          "FAQ ERROR:",
          error
        );

        console.error(
          "FAQ ERROR RESPONSE:",
          error.response
        );

        if (!cancelled) {
          setFaqs([]);

          setError(
            error.response?.data?.message ||
              "Unable to load FAQs."
          );
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadFaqs();

    return () => {
      cancelled = true;
    };
  }, [languageId]);

  // =====================================================
  // TOGGLE FAQ
  // =====================================================

  const toggleFaq = (faqId) => {
    setActiveFaq((current) =>
      current === faqId
        ? null
        : faqId
    );
  };

  // =====================================================
  // RENDER
  // =====================================================

  return (
    <div className="professional-faq-page">

      {/* =================================================
          HERO
      ================================================= */}

      <section className="professional-faq-hero">

        <div className="professional-faq-overlay"></div>

        <div className="container">

          <div className="professional-faq-hero-content">

            <div className="faq-breadcrumb">
              <span>
                Home
              </span>

              <i className="fa fa-angle-right"></i>

              <span>
                FAQ
              </span>
            </div>

            <span className="faq-eyebrow">
              CRETE HOLIDAYS
            </span>

            <h1>
              Frequently Asked Questions
            </h1>

            <p>
              Everything you need to know about
              renting a car and enjoying your
              holiday in Crete.
            </p>

          </div>

        </div>

      </section>


      {/* =================================================
          FAQ MAIN
      ================================================= */}

      <section className="professional-faq-section">

        <div className="container">

          <div className="row">

            {/* ==========================================
                LEFT INFORMATION
            ========================================== */}

            <div className="col-lg-4">

              <div className="faq-intro">

                <span className="faq-section-label">
                  NEED HELP?
                </span>

                <h2>
                  We have answers.
                </h2>

                <p>
                  Find quick answers to the most
                  frequently asked questions about
                  our car rental services.
                </p>

                <p>
                  Still have questions? Our team is
                  always happy to help you plan your
                  perfect trip around Crete.
                </p>


                {/* CONTACT CARD */}

                <div className="faq-contact-card">

                  <div className="faq-contact-icon">
                    <i className="fa fa-headset"></i>
                  </div>

                  <div>

                    <span>
                      Need more help?
                    </span>

                    <strong>
                      Contact our team
                    </strong>

                  </div>

                </div>

              </div>

            </div>


            {/* ==========================================
                FAQ LIST
            ========================================== */}

            <div className="col-lg-8">

              {loading && (

                <div className="professional-faq-loading">

                  <div className="faq-spinner"></div>

                  <p>
                    Loading frequently asked
                    questions...
                  </p>

                </div>

              )}


              {!loading && error && (

                <div className="professional-faq-error">

                  <i className="fa fa-circle-exclamation"></i>

                  <h4>
                    Unable to load FAQs
                  </h4>

                  <p>
                    {error}
                  </p>

                </div>

              )}


              {!loading &&
                !error &&
                faqs.length > 0 && (

                  <div className="professional-faq-list">

                    {faqs.map(
                      (faq, index) => {

                        const isActive =
                          activeFaq ===
                          faq.faq_id;

                        return (

                          <div
                            className={`professional-faq-item ${
                              isActive
                                ? "active"
                                : ""
                            }`}
                            key={
                              faq.faq_id
                            }
                          >

                            {/* QUESTION */}

                            <button
                              type="button"
                              className="professional-faq-question"
                              onClick={() =>
                                toggleFaq(
                                  faq.faq_id
                                )
                              }
                            >

                              <div className="faq-question-left">

                                <span className="faq-index">
                                  {String(
                                    index + 1
                                  ).padStart(
                                    2,
                                    "0"
                                  )}
                                </span>

                                <span className="faq-question-text">
                                  {
                                    faq.faq_ques
                                  }
                                </span>

                              </div>

                              <span className="faq-toggle">

                                <i
                                  className={`fa ${
                                    isActive
                                      ? "fa-minus"
                                      : "fa-plus"
                                  }`}
                                ></i>

                              </span>

                            </button>


                            {/* ANSWER */}

                            <div
                              className={`professional-faq-answer ${
                                isActive
                                  ? "open"
                                  : ""
                              }`}
                            >

                              <div
                                className="professional-faq-answer-inner"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    faq.faq_ans ||
                                    "",
                                }}
                              />

                            </div>

                          </div>

                        );
                      }
                    )}

                  </div>

                )}


              {!loading &&
                !error &&
                faqs.length === 0 && (

                  <div className="professional-faq-empty">

                    <i className="fa fa-circle-question"></i>

                    <h3>
                      No FAQs available
                    </h3>

                    <p>
                      There are currently no
                      frequently asked questions
                      available.
                    </p>

                  </div>

                )}

            </div>

          </div>

        </div>

      </section>


      {/* =================================================
          BOTTOM CTA
      ================================================= */}

      <section className="faq-bottom-cta">

        <div className="container">

          <div className="faq-bottom-cta-inner">

            <div>

              <span>
                READY TO EXPLORE CRETE?
              </span>

              <h2>
                Your journey starts here.
              </h2>

            </div>

            <div>

              <button
                type="button"
                className="faq-book-button"
                onClick={() =>
                  window.location.href =
                    "/bookacar"
                }
              >
                Book a car
                <i className="fa fa-arrow-right"></i>
              </button>

            </div>

          </div>

        </div>

      </section>
 <ImportantToKnow />
    </div>
  );
};

export default FAQ;